import React, { useState, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import './LoginPage.css'; // Gaya dasar
import './LoginAnimation.css'; // Gaya dan animasi floating label
import { showErrorAlert } from '../utils/alert';
import { Link, useNavigate } from 'react-router-dom';

import logo from '../assets/images/logo.png';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState(''); 
  const [loading, setLoading] = useState(false);

  const { login } = useContext(AuthContext);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      const errorResponse = err.response;

      if (errorResponse && errorResponse.status === 401 && errorResponse.data.redirect) {
        showErrorAlert(errorResponse.data.message);
        navigate('/verify-otp', { 
          state: { 
            userId: errorResponse.data.userId, 
            email: email 
          } 
        });
      } else {
        showErrorAlert(errorResponse?.data?.message || 'Email atau password salah.');
      }
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <form className="login-form-card" onSubmit={handleLogin}>

        <div className="login-header">
          <img src={logo} alt="Logo Kendis SKP" className="login-logo-img" />
          <h1 className="login-title">Ms. Kendis SKP</h1>
          <p className="login-subtitle">
            Monitoring Servis Rutin Kendaraan Dinas Staf Khusus Presiden
          </p>
        </div>
        
        <div className="form-group-floating">
          <input
            type="email"
            id="email"
            className="form-input"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError('');
            }}
            placeholder=" "
            required
            autoComplete="username"
          />
          <label htmlFor="email" className="form-label">Email</label>
          {emailError && <span className="input-error-message">{emailError}</span>}
        </div>

        {/* --- Input Group untuk Password --- */}
        <div className="form-group-floating">
          <input
            type="password"
            id="password"
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder=" " /* Penting untuk floating label CSS */
            required
            autoComplete="current-password" /* Membantu browser mengisi otomatis */
          />
          <label htmlFor="password" className="form-label">Password</label>
          <Link to="/forgot-password" style={{ fontSize: '12px', textDecoration: 'none' }}>Lupa Password?</Link>
        </div>

        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '14px' }}>
          Belum punya akun? <Link to="/register">Buat akun baru</Link>
        </p>
      </form>
    </div>
  );
};

export default LoginPage;